import React from 'react';
import Paper from 'material-ui/Paper';

export const Page = props => {
	const { title } = props;
	return (
		<Paper style={{ padding: 16 }}>
			<h3 className="articles-header--title">{title}</h3>
			<div>{props.children}</div>
		</Paper>
	);
};



// WEBPACK FOOTER //
// src/components/page/page.js